import { createSelector } from '@ngrx/store';
import { InstrumentType } from '@zero/shared/util-models';
import { savingPlansFeature } from './saving-plans.reducers';

export const selectSavingsPlans = createSelector(savingPlansFeature.selectSavingsPlansOverview, (overview) => overview?.savingsPlans);
export const selectSavingsPlansDirectDebitActive = createSelector(
  savingPlansFeature.selectSavingsPlansOverview,
  (overview) => overview?.directDebitActive,
);
export const selectSavingsPlansOverviewLoading = createSelector(
  savingPlansFeature.selectSavingsPlansOverviewLoadingState,
  (savingPlansOverviewLoadingState) => savingPlansOverviewLoadingState === 'LOADING',
);
export const selectSavingsPlansOverviewInitiallyLoaded = createSelector(
  savingPlansFeature.selectSavingsPlansOverviewLoadingState,
  (savingPlansOverviewLoadingState) => savingPlansOverviewLoadingState === 'LOADED',
);
export const selectSavingPlanById = (id: string) =>
  createSelector(savingPlansFeature.selectSavingsPlansOverview, (overview) =>
    overview?.savingsPlans.find((savingPlan) => savingPlan.id === id),
  );

export const selectMostChosenSavingPlansLoading = createSelector(
  savingPlansFeature.selectMostChosenSavingPlansLoadingState,
  (mostChosenSavingPlansLoadingState) => mostChosenSavingPlansLoadingState === 'LOADING',
);
export const selectMostChosenSavingPlansInitiallyLoaded = createSelector(
  savingPlansFeature.selectMostChosenSavingPlansLoadingState,
  (mostChosenSavingPlansLoadingState) => mostChosenSavingPlansLoadingState === 'LOADED',
);
export const selectExecDatesLoading = createSelector(
  savingPlansFeature.selectExecDatesLoadingState,
  (execDatesLoadingState) => execDatesLoadingState === 'LOADING',
);
export const selectExecDatesInitiallyLoaded = createSelector(
  savingPlansFeature.selectExecDatesLoadingState,
  (execDatesLoadingState) => execDatesLoadingState === 'LOADED',
);
export const selectNextExecDate = createSelector(savingPlansFeature.selectExecDates, (execDates) => execDates?.[0]);
export const selectSavingsPlanSubjectsLoading = createSelector(
  savingPlansFeature.selectSavingsPlanSubjectsLoadingState,
  (savingsPlanSubjectsLoadingState) => savingsPlanSubjectsLoadingState === 'LOADING',
);
export const selectSavingsPlanSubjectsInitiallyLoaded = createSelector(
  savingPlansFeature.selectSavingsPlanSubjectsLoadingState,
  (savingsPlanSubjectsLoadingState) => savingsPlanSubjectsLoadingState === 'LOADED',
);
export const selectHasCryptoSavingsPlanSelected = createSelector(savingPlansFeature.selectMultiSavingsPlans, (savingsPlans) =>
  savingsPlans.some((savingsPlan) => savingsPlan?.asset?.instrumentType === InstrumentType.Crypto),
);
export const selectHasErrors = createSelector(
  savingPlansFeature.selectMultiSavingsPlans,
  (savingsPlans) =>
    !savingsPlans?.length || savingsPlans.some(({ error }) => error) || savingsPlans.some(({ amount }) => !amount || amount <= 0),
);
export const selectHasValidForm = createSelector(
  selectHasErrors,
  savingPlansFeature.selectExecDate,
  savingPlansFeature.selectInterval,
  (hasErrors: boolean, execDate, interval) => {
    return Boolean(!hasErrors && execDate && interval);
  },
);
export const selectMultiSavingsPlansAssets = createSelector(savingPlansFeature.selectMultiSavingsPlans, (savingsPlans) =>
  savingsPlans.map((savingsPlan) => savingsPlan?.asset),
);
export const selectIsMultiSavingsPlanOrder = createSelector(
  savingPlansFeature.selectMultiSavingsPlans,
  (savingsPlans) => savingsPlans.length > 1,
);
export const selectMultiSavingsPlanSum = createSelector(savingPlansFeature.selectMultiSavingsPlans, (savingsPlans) =>
  savingsPlans.reduce((acc, { amount }) => acc + amount, 0),
);
export const selectHasMultipleIntervals = createSelector(savingPlansFeature.selectIntervals, (intervals) => intervals.length > 1);
export const selectMultiSavingsPlansWithAssetsNoSavings = createSelector(savingPlansFeature.selectMultiSavingsPlans, (savingsPlans) =>
  savingsPlans.filter((savingsPlan) => savingsPlan?.asset && !savingsPlan.asset.sparplan),
);

export const selectHasValidOnboardingSavingsPlan = createSelector(
  savingPlansFeature.selectOnboardingSavingsPlans,
  (savingsPlans) => !!savingsPlans?.some((savingsPlan) => savingsPlan.status === 'created'),
);
